/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useState, useContext, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Box, Dialog, Slide,
} from '@mui/material';
import { useLocation, useHistory, Link } from 'react-router-dom';
import PlacesAutocomplete from '../../components/PlacesAutocomplete';
import './geoDashboard.css';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { sendRequest } from '../../api/shootAPI';
import LocationHistory from '../../components/LocationHistory';
import { Navbar, Sidebar } from '../../components';
import DataTable from '../../components/DataTable';
import StatusPill from '../../components/StatusPill';
import useDebounce from '../../hooks/useDebounce';
import useProfilePictureUrl from '../../hooks/useProfilePictureUrl';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const PAGE_SIZE = 10;

const AVATAR_PALETTE = [
  { bg: '#fdebe6', fg: '#b94f3c' },
  { bg: '#fde6d2', fg: '#F19235' },
  { bg: '#eef5ea', fg: '#53A551' },
  { bg: '#e8eef7', fg: '#4062E5' },
  { bg: '#f5e6f7', fg: '#9333ea' },
];

function avatarColors(key) {
  const str = String(key || '');
  let h = 0;
  // eslint-disable-next-line no-bitwise
  for (let i = 0; i < str.length; i += 1) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

// DS appearance for the shared PlacesAutocomplete's MUI outlined input.
const PLACES_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    fontSize: '14px',
    backgroundColor: '#fff',
    '& fieldset': { borderColor: '#e0e1e6' },
    '&:hover fieldset': { borderColor: '#e0e1e6' },
    '&.Mui-focused fieldset': { borderColor: '#3d5a8a', borderWidth: '1px', boxShadow: 'none' },
  },
};

// Geo-local member cell — mirrors Manage Members' NameCell (stacked name + email,
// name falls back to email, truncated) and adds photo-or-initials avatar.
function MemberCell({ member }) {
  const firstName = member.user?.firstName || '';
  const lastName = member.user?.lastName || '';
  const email = member.user?.email;
  const fullName = `${firstName} ${lastName}`.trim() || email || '—';
  const photoUrl = useProfilePictureUrl(member.user?.profilePicture, member.id);
  const c = avatarColors(email || member.id);
  const initials = (firstName && lastName)
    ? `${firstName[0]}${lastName[0]}`.toUpperCase()
    : (email ? email.slice(0, 2).toUpperCase() : '?');

  return (
    <div className="flex items-center gap-3 min-w-0">
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden"
        style={photoUrl
          ? { backgroundImage: `url(${photoUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
          : { backgroundColor: c.bg, color: c.fg, fontSize: 11, fontWeight: 600 }}
      >
        {!photoUrl && initials}
      </div>
      <div className="min-w-0">
        <Link
          to={`/profile/${member.id}`}
          className="block text-ink-900 truncate hover:text-brand-700 hover:underline"
          style={{ fontSize: 14, fontWeight: 500, lineHeight: '20px' }}
        >
          {fullName}
        </Link>
        <p className="text-ink-500 truncate" style={{ fontSize: 11, lineHeight: '16px', marginTop: 2 }}>
          {email}
        </p>
      </div>
    </div>
  );
}
MemberCell.propTypes = { member: PropTypes.shape({}).isRequired };

const unresolvedPill = (addressSaved, totalCount) => {
  if (!addressSaved) return { tone: 'warning', label: 'No Address Saved' };
  if (!totalCount) return { tone: 'success', label: 'None' };
  return { tone: 'error', label: `${totalCount} Away` };
};

function GeoDashboard() {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const page = query.get('page');
  const history = useHistory();
  const { debounce } = useDebounce();

  const { activeWorkspace } = useContext(UserContext);
  const [members, setMembers] = useState([]);
  const [sortKey, setSortKey] = useState('');
  const [sortOrder, setSortOrder] = useState('');
  const [currentPage, setCurrentPage] = useState(page ? parseInt(page, 10) : 1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedMember, setSelectedMember] = useState();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [homeAddress, setHomeAddress] = useState({ latlng: null, location: null });

  const onClickHistory = (member) => {
    setSelectedMember(member);
    setIsOpenModal(true);
  };

  const handleClose = () => setIsOpenModal(false);

  const handleCloseUpdateAddressModal = () => {
    setIsOpenUpdateModal(false);
    setHomeAddress({ latlng: null, location: null });
  };

  const onClickUpdateAddress = (member) => {
    setSelectedMember(member);
    setIsOpenUpdateModal(true);
  };

  const getMembers = async (params) => {
    setIsLoading(true);
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.membersGeolocations(activeWorkspace.id),
      params: { pageSize: PAGE_SIZE, ...params },
    });
    if (response.success) {
      setMembers(response.data?.list ?? []);
      setIsLoading(false);
      if (response.data?.list && selectedMember) {
        response.data.list.forEach((member) => {
          if (member.id === selectedMember.id) setSelectedMember(member);
        });
      }
      setTotalPages(response.data?.totalPages ?? 1);
    } else {
      setIsLoading(false);
    }
  };

  const handleUpdateAddress = async () => {
    const response = await sendRequest({
      method: 'post',
      url: API.USER.updateAddress,
      data: { ...homeAddress, userId: selectedMember.user.id },
    });
    if (response.success) {
      getMembers({ page: currentPage, sortKey, sortOrder });
      handleCloseUpdateAddressModal();
    }
  };

  const handlePageChange = (next) => {
    setCurrentPage(next);
    history.push(`?page=${next}`);
  };

  const toggleSort = debounce((key) => {
    setSortKey(key);
    setSortOrder((prev) => (key === sortKey ? (prev === 'asc' ? 'desc' : 'asc') : 'asc'));
  }, 200);

  useEffect(() => {
    getMembers({ page: currentPage, sortKey, sortOrder });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, sortKey, sortOrder]);

  const columns = [
    {
      key: 'name',
      label: 'User',
      sortable: true,
      width: 260,
      flex: true,
      render: (m) => <MemberCell member={m} />,
    },
    {
      key: 'homeAddress',
      label: 'Home Address',
      sortable: false,
      width: 320,
      flex: true,
      render: (m) => (m?.user?.userLocation?.formattedAddress
        ? <span className="text-ink-900">{m.user.userLocation.formattedAddress}</span>
        : (
          <button
            type="button"
            onClick={() => onClickUpdateAddress(m)}
            data-testid="update-address"
            className="text-brand-500 underline hover:text-brand-700 bg-transparent border-0 p-0 cursor-pointer"
          >
            Update Address
          </button>
        )),
    },
    {
      key: 'unresolved',
      label: 'Unresolved',
      sortable: true,
      width: 130,
      render: (m) => {
        const { tone, label } = unresolvedPill(
          !!m?.user?.userLocation?.formattedAddress,
          m?.locationViolations?.length,
        );
        return <StatusPill tone={tone}>{label}</StatusPill>;
      },
    },
    {
      key: 'actions',
      label: 'View Location History',
      sortable: false,
      width: 180,
      align: 'center',
      render: (m) => {
        const addressSaved = !!m?.user?.userLocation?.formattedAddress;
        return (
          <button
            type="button"
            onClick={() => onClickHistory(m)}
            disabled={!addressSaved}
            data-testid="view-history"
            className="inline-flex items-center justify-center px-3 py-1.5 rounded-[8px] text-[11px] font-semibold uppercase tracking-wider text-ink-900 bg-white border border-rule hover:border-brand-500 hover:text-brand-700 disabled:opacity-40 disabled:cursor-not-allowed transition whitespace-nowrap"
            style={{ borderStyle: 'solid', letterSpacing: '0.05em' }}
          >
            View History
          </button>
        );
      },
    },
  ];

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <div className="mb-5">
            <h1
              className="font-bold text-ink-900 leading-tight truncate text-2xl lg:text-[32px] lg:leading-10"
              data-testid="title"
              data-tour="geo"
            >
              Geo Dashboard
            </h1>
            <p className="text-sm text-ink-500 mt-1" data-testid="subtitle">
              View work location history and violations
            </p>
          </div>

          <DataTable
            columns={columns}
            rows={members}
            getRowKey={(m) => m.id}
            sortKey={sortKey}
            sortDir={sortOrder || 'asc'}
            onSort={toggleSort}
            loading={isLoading}
            emptyText="No members found."
            page={currentPage}
            pageSize={PAGE_SIZE}
            total={totalPages * PAGE_SIZE}
            onPageChange={handlePageChange}
            minWidth={900}
          />
        </div>
      </div>

      {/* Location history (full-screen) */}
      <Dialog fullScreen open={isOpenModal} onClose={handleClose} TransitionComponent={Transition}>
        <LocationHistory
          user={selectedMember?.user}
          handleClose={handleClose}
          onResolve={getMembers}
          locationViolations={selectedMember?.locationViolations}
        />
      </Dialog>

      {/* Update home address */}
      {isOpenUpdateModal && (
        <Modal open onClose={handleCloseUpdateAddressModal} className="flex-row align-c jstfy-c" data-testid="update-address-modal">
          <Box style={{
            width: 560,
            maxWidth: 'calc(100% - 32px)',
            padding: 24,
            background: '#fff',
            borderRadius: 12,
          }}
          >
            <h5 className="text-lg font-semibold leading-none text-ink-900 mb-5" data-testid="modal-title">
              Update Home Address
            </h5>
            <PlacesAutocomplete
              location={homeAddress.location}
              onChange={setHomeAddress}
              textfieldType="outlined"
              label="Home Address"
              inlineLabel
              placeholder="Enter Street Address"
              textFieldSx={PLACES_SX}
            />
            <div className="flex justify-start items-center gap-2 mt-6">
              <button
                type="button"
                onClick={handleCloseUpdateAddressModal}
                data-testid="cancel"
                className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
                style={{ borderStyle: 'solid' }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleUpdateAddress}
                disabled={!homeAddress.latlng}
                data-testid="update"
                className="inline-flex items-center justify-center px-4 py-2 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
              >
                Update
              </button>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
}

GeoDashboard.propTypes = {};

export default GeoDashboard;
